export default __webpack_public_path__ + "static/media/box.8b08b823.svg";